import { combineReducers } from 'redux'

import { POSTS_RECEIVED } from 'wordpress/constants'
import { SET_NEWS } from 'news/constants'

const categories = (state = [], action) => {
    if (action.type === POSTS_RECEIVED && action.kind === 'categories') {
        return action.result.posts
    }

    return state
}

const newsList = (state = { posts: [], paging: null }, { type, posts, paging }) =>
    type === SET_NEWS ? { posts: paging.page > 1 ? [...state.posts, ...posts] : posts, paging } : state

export const news = combineReducers({
    categories,
    newsList,
})
